import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tableApprovalLogsView.
 * @extends JetView
 */
export default class tableApprovalLogsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the datatable
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'ActionTittle', // Column ID
                                    header: '', // Column header
                                    width: 65, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Acción'), // Tooltip text
                                    template: function (obj) {
                                        // Template function for rendering cell content
                                        if (obj.StateId !== 'P') {
                                            return ''; // Return empty if StateId is not 'P'
                                        } else {
                                            if (devConfig.getPermAction('approvalLogsApprove', 'Approve')) {
                                                // Check permission for approval action
                                                return "<span class='webix_icon wxi-close approve prm-approvalLogsApprove'></span><span class='webix_icon wxi-close torefuse prm-approvalLogsApprove'></span>";
                                            } else {
                                                return ''; // Return empty if no permission
                                            }
                                        }
                                    },
                                },
                                {
                                    id: 'Country', // Column ID
                                    header: _('País'), // Column header
                                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Hide column based on permission
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 50, // Column width
                                    sort: 'int', // Sorting type
                                    template: function (obj) {
                                        // Template function for rendering cell content
                                        return (
                                            "<i class='flags " + obj.Country + "'></i>" // Render country flag
                                        );
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'Id', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Time', // Column ID
                                    header: _('Fecha'), // Column header
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 200, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'UserName', // Column ID
                                    header: _('ID Usuario'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserNameRequest', // Column ID
                                    header: _('Usuario Solicita'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserNameApproval', // Column ID
                                    header: _('Usuario Aprueba'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Field', // Column ID
                                    header: _('Campo'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'OldValue', // Column ID
                                    header: _('Antiguo'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'NewValue', // Column ID
                                    header: _('Nuevo'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'StateId', // Column ID
                                    header: _('Estado'), // Column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Aprobada') },
                                        { id: 'R', value: _('Rechazada') },
                                        { id: 'P', value: _('Pendiente') },
                                    ],
                                    width: 110, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Imagen', // Column ID
                                    header: _('Imagen'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                    hidden: true, // Hide column
                                },
                            ],
                            onClick: {
                                // Event handlers for click events
                                torefuse: function (euv, id) {
                                    // Handler for 'torefuse' action
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        type: 'confirm-warning', // Confirmation type
                                        text: _('Advertencia!') + '<br/>' + _('Desea Rechazar el log?'), // Confirmation message
                                        ok: _('Rechazar log'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            // Callback for confirmation action
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the clicked item
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type for AJAX request
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Security/UpdateLogs', // API endpoint
                                                        '{"Id":"' + item.Id + '", "State":"R"}', // Request payload
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    _('Error! '), // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var json = JSON.parse(
                                                                    text, // Parse response
                                                                );
                                                                if (json.HasError) {
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error', // Alert type
                                                                        text: _(
                                                                            'Ocurrio un error, comuniquese con soporte', // Error message
                                                                        ),
                                                                    });
                                                                } else {
                                                                    webix.message({
                                                                        text: _(
                                                                            'Estado de log actualizado', // Success message
                                                                        ),
                                                                        title: _('¡Exito!'),
                                                                        type: 'alert-warning', // Alert type
                                                                    });
                                                                    item.StateId = 'R'; // Update item state
                                                                    $$('datatable').refresh(); // Refresh datatable
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                approve: function (euv, id) {
                                    // Handler for 'approve' action
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        type: 'confirm-warning', // Confirmation type
                                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar el log?'), // Confirmation message
                                        ok: _('Aprobar log'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            // Callback for confirmation action
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the clicked item
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type for AJAX request
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Security/UpdateLogs', // API endpoint
                                                        '{"Id":"' + item.Id + '", "State":"A"}', // Request payload
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    _('Error! '), // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                console.log(
                                                                    text, // Log response
                                                                );
                                                                var json = JSON.parse(
                                                                    text, // Parse response
                                                                );
                                                                if (json.HasError) {
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error', // Alert type
                                                                        text: _(
                                                                            'Ocurrio un error, comuniquese con soporte', // Error message
                                                                        ),
                                                                    });
                                                                } else {
                                                                    webix.message({
                                                                        text: _(
                                                                            'Estado de log actualizado', // Success message
                                                                        ),
                                                                        title: _('¡Exito!'),
                                                                        type: 'alert-warning', // Alert type
                                                                    });
                                                                    item.StateId = 'A'; // Update item state
                                                                    $$('datatable').refresh(); // Refresh datatable
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            on: {
                                // Event handlers for datatable events
                                onItemDblClick: function () {
                                    $$('editwin').show(); // Show edit window on double click
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead option
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch setting
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable
        var url = devConfig.geturlApi() + 'UserManagement/GetUserLogs'; // API endpoint for user logs
        var vthis = this; // Reference to the current instance
        var filter = ''; // Filter string
        this.on(this.app, 'requests:filter', (filterData) => {
            // Event listener for filter requests
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter string
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            $$('consultButton').define('disabled', true); // Disable consult button
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1) // Load data with filters
                .then((response) => {
                    $$('consultButton').define('disabled', false); // Enable consult button after load
                })
                .catch((e) => {
                    $$('consultButton').define('disabled', false); // Enable consult button on error
                });
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event listener for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        var ttt = webix.ui({
            // Create edit window UI
            view: 'window', // Window component
            move: true, // Enable window movement
            id: 'editwin', // Window ID
            fullscreen: screen.width < 500 ? true : false, // Fullscreen option based on screen width
            head: {
                view: 'toolbar', // Toolbar component
                cols: [
                    { view: 'label', label: _('Editar'), align: 'center' }, // Label for editing
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on close
                        },
                    },
                ],
            },
            modal: true, // Modal window
            position: 'center', // Center position
            body: {
                view: 'form', // Form component
                id: 'editform', // Form ID
                elements: [
                    {
                        view: 'text', // Text input for UserName
                        label: _('ID Usuario'),
                        name: 'UserName',
                        readonly: true, // Read-only field
                    },
                    {
                        view: 'imageLabel', // Image label for displaying image
                        name: 'Imagen',
                        width: 500, // Width of the image
                        height: 500, // Height of the image
                    },
                    {
                        cols: [
                            {
                                view: 'button', // Button to close the edit window
                                value: _('Listo'),
                                click: function () {
                                    this.getTopParentView().hide(); // Hide window on button click
                                },
                            },
                        ],
                    },
                ],
            },
        });
        $$('editform').bind($$('datatable')); // Bind the form to the datatable
    }
}

// Extend webix UI to create a custom imageLabel component
webix.protoUI(
    {
        name: 'imageLabel', // Component name
        setValue: function (value) {
            // Set value method for the component
            this.setHTML(
                "<img style='width:100%;height: 100%;' src='" + value + "'></img>", // Set HTML for displaying the image
            );
        },
    },
    webix.ui.label, // Base component
);

// FILE DOCUMENTED
